import React from 'react'
import {Row, Col, Button} from 'reactstrap';
import moment from 'moment';
import {formatCurrency} from '../utils/Strings'

export default class CourseRow extends React.Component{
  
  handleReserve(idx){
    //alert(idx)
    this.props.onCourseChoose(idx)
  }
  renderAction() {
    var c=this.props.course
    if (c.totalPrice)
      return (
        <Col xs="auto" className="ml-auto">      
          <Button 
            color="danger"
            onClick={() => this.handleReserve(this.props.index)}
          >
            Rezerwuj
          </Button>
        </Col>  
      )
  }
  render (){
    var c=this.props.course      
    var strCourseDate=moment(c.startDateTime).format('YYYY-MM-DD')
    var strCourseTime=(
      <div>
        <span className="startTime">{moment(c.startDateTime).format('HH:mm')}</span>
        {'-'}
        <span className="finishTime">{moment(c.finishDateTime).format('HH:mm')}</span>
      </div>
    )    
    var strQty=''
    if (this.props.qtyNormal)
      strQty += this.props.qtyNormal + "N "
    if (this.props.qtyReduced)
      strQty += this.props.qtyReduced + "U"

    return (      
      <Row className="align-items-center">
        <Col md="2" xs="5">
        <div className="town">{c.startTown}</div>
        <div className="street">{c.startAddress}</div>
        </Col>
      
        <Col md="2" xs="5">
        <div className="town">{c.finishTown}</div>
        <div className="street">{c.finishAddress}</div>
        </Col>  
        
        <Col md="2" xs="2" className="companyName">{c.companyName}</Col>
        
        <Col md="2" xs="5">
        <div className="courseDate">{strCourseDate}</div>
        {strCourseTime}
        </Col> 
             
        <Col md="1" xs="2">{strQty}</Col>   
      
        <Col md="1" xs="2">{formatCurrency(c.totalPrice)}</Col>  
        
        {this.renderAction()}
              
      </Row>      
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/CourseRow.js